module.exports = __webpack_public_path__ + "static/img/chat2.3718128.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/championscity/challenge/chat2.png
// module id = F/BT
// module chunks = 1